export enum PACKAGE_ITEM_RESOLUTION {
  FACTURADO = 0,
  CUBIERTO_POR_GARANTIA = 1,
  BONIFICADO = 2,
  RESOLUCION_AUTOMATICA = 3,
  NADA_QUE_FACTURAR = 4,
}

export const PackageItemResolutionString = {
  [PACKAGE_ITEM_RESOLUTION.FACTURADO]: 'Facturado',
  [PACKAGE_ITEM_RESOLUTION.CUBIERTO_POR_GARANTIA]: 'Cubierto por Garantía',
  [PACKAGE_ITEM_RESOLUTION.BONIFICADO]: 'Bonificado',
  [PACKAGE_ITEM_RESOLUTION.NADA_QUE_FACTURAR]: 'Nada que facturar',
  [PACKAGE_ITEM_RESOLUTION.RESOLUCION_AUTOMATICA]: 'Resolución automática',
};

export enum PACKAGE_ITEM_STOCK_RESOLUTION {
  RESUELTO = 0,
  NO_RESUELTO = 1,
}

export const PackageItemStockResolutionString = {
  [PACKAGE_ITEM_STOCK_RESOLUTION.RESUELTO]: 'Resuelto',
  [PACKAGE_ITEM_STOCK_RESOLUTION.NO_RESUELTO]: 'No resuelto',
};
